















































import tradingService from '@/services/tradingService';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import { Wallet } from '@/store/wallet/types';
import { centsToEuro } from '@/filters/currency';
import { Trade } from '@/store/sellOffer/types';
import { Asset } from '@/store/asset/types';
import { CustodyProviders } from '@/enum/trades/CustodyTypes';

import ExporoTable from '@/components/common/Table.vue';
import ExporoTooltip from '@/components/common/Tooltip.vue';

@Component({
  name: 'my-securities-view',
  filters: {
    centsToEuro,
  },
  components: {
    ExporoTable,
    ExporoTooltip,
  },
})
export default class MySecuritiesView extends Vue {
  @Action('appState/startLoader') startLoader;
  @Action('appState/stopLoader') stopLoader;
  @Getter('appState/isLoading') isLoading?: boolean;
  @Getter('profile/userId') userId?: number;

  private data: Asset[] = [];

  get assets(): Asset[] {
    if (this.data && this.data.length > 0){
      return this.data.filter(asset => asset.pieces > 0 || asset.source > 0);
    }

    return [];
  }

  get tableData(): Array<object> {
    if (this.assets && this.assets.length > 0) {
      return this.assets
        .map(asset => ({
          [ this.$t('mySecurities.table.header', { context: 'contractTitle' }) ]: {
            text: asset.title,
            value: asset.title,
          },
          [ this.$t('mySecurities.table.header', { context: 'pieces' }) ]: {
            text: asset.source,
            value: asset.source,
          },
          [ this.$t('mySecurities.table.header', { context: 'unitPrice' }) ]: {
            text: this.$options.filters.centsToEuro(asset.unit_price),
            value: asset.unit_price,
          },

          [ this.$t('mySecurities.table.header', { context: 'total' }) ]: {
            text: this.$options.filters.centsToEuro(asset.unit_price * asset.source),
            value: asset.unit_price,
          },
          [ this.$t('mySecurities.table.header', { context: 'provider' }) ]: {
            text: this.getProvider(asset.provider).text,
            value: asset.provider,
          },
          [ this.$t('mySecurities.table.header', { context: 'available' }) ]: {
            text: asset.pieces,
            value: asset.pieces,
          },
          [ this.$t('mySecurities.table.header', { context: 'actions' }) ]: {
            text: '',
            value: asset.asset_id,
            slotId: `actions-${asset.asset_id}`,
          },
        }));
    }

    return [];
  }

  async mounted() {
    this.getAssets();
  }

  async getAssets() {
    try {
      this.startLoader();
      this.data = (await tradingService.getMySecurities()).data;

      this.stopLoader();
    } catch (error) {
      this.stopLoader();
    }
  }

  private getProvider(value: string) {
    return Object.keys(CustodyProviders)
      .map(provider => CustodyProviders[provider])
      .find((provider) => provider.value === value);
  }

  private showActionsTooltip(row){
    const pieces = this.$t('mySecurities.table.header', { context: 'pieces' });
    const actions = this.$t('mySecurities.table.header', { context: 'actions' });

    const hasPieces = row[pieces].value > 0;
    const hasActionSlot = !!row[actions].slotId;

    return hasPieces && hasActionSlot;
  }
};
